<template>
  <div class="not-found">
    <div class="container text-center">
      <div class="error-code">404</div>
      <h1>Seite nicht gefunden</h1>
      <p>Die angeforderte Seite konnte leider nicht gefunden werden.</p>
      <div class="cta-buttons mt-5">
        <router-link to="/" class="btn-primary">Zurück zur Startseite</router-link>
        <router-link to="/kontakt" class="btn-secondary">Kontakt aufnehmen</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style lang="scss" scoped>
@use "@/assets/css/global.scss" as *;

.not-found {
  min-height: 100vh;
  padding: 150px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(145deg, #fafcfd, #e8f0f5);
}

.error-code {
  font-size: 12rem;
  font-weight: 900;
  background: $primary-gradient;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  line-height: 1;
  margin-bottom: 1rem;
  text-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
  
  @media (max-width: 768px) {
    font-size: 8rem;
  }
}

h1 {
  font-size: 3rem;
  margin-bottom: 1.5rem;
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
}

p {
  font-size: 1.2rem;
  color: $text-muted;
  margin-bottom: 2rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}
</style>